import { DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.scss'],
  standalone: false
})
export class LogoutPageComponent {
  private document = inject(DOCUMENT);

  backToApp(): void {
    console.log('backToApp');
    if (this.document.defaultView) {
      this.document.defaultView.location.href = '/';
    }
  }
}
